export function BrandTag() {
  return (
    <span className="rounded-sm border border-primary-500/20 bg-primary-100 px-1 text-micro font-medium text-primary-900">
      you
    </span>
  )
}
